import { useEffect, useState } from 'react';
import { resolvePopupProfile, postSocialErrorToOpener, postSocialResultToOpener } from '../utils/socialAuth';

function SocialAuthCallback() {
  const [message, setMessage] = useState('Completing social login...');

  useEffect(() => {
    let isMounted = true;

    async function finishLogin() {
      const provider = new URL(window.location.href).searchParams.get('provider') || '';

      try {
        const result = await resolvePopupProfile(provider, window.location.href);

        if (!isMounted) {
          return;
        }

        postSocialResultToOpener(result);
        setMessage('Login complete. You can close this window.');
      } catch (error) {
        if (!isMounted) {
          return;
        }

        postSocialErrorToOpener(provider, error.message);
        setMessage(error.message || 'Social login could not be completed.');
      } finally {
        window.setTimeout(() => {
          window.close();
        }, 800);
      }
    }

    finishLogin();

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <div className="min-vh-100 d-flex align-items-center justify-content-center px-4 text-center">
      <div>
        <h3 className="fw-semibold mb-3">Social Sign In</h3>
        <p className="mb-0">{message}</p>
      </div>
    </div>
  );
}

export default SocialAuthCallback;
